import React from 'react';
import ArrModal, {ModalButton} from '../../common/arr-modal/ArrModal';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import './ConfirmationModal.scss';

interface ConfirmationModalProps {
  open: boolean;
  handleCancel: () => void;
  handleApply: () => void;
  handleNotification: () => void;
  from: string;
}

const ConfirmationModal = ({
  open,
  handleCancel,
  handleApply,
  handleNotification,
  from,
}: ConfirmationModalProps) => {
  const notificationButtons: ModalButton[] =
    from === 'continue-notification'
      ? [
          {
            id: '1',
            label: t('categorization.notificationModal.getNotified'),
            onClick: handleNotification,
            variant: 'secondary',
            dataTestId: 'notif-modal-confirm-btn',
          },
          {
            id: '2',
            label: t('categorization.notificationModal.waitForResults'),
            onClick: handleApply,
            variant: 'primary',
            dataTestId: 'notif-modal-confirm-btn',
          },
          {
            id: '3',
            label: t('common.cancel'),
            onClick: handleCancel,
            variant: 'text',
            dataTestId: 'notif-modal-cancel-btn',
          },
        ]
      : [
          {
            id: '1',
            label: t('common.ok'),
            onClick: handleCancel,
            variant: 'secondary',
            dataTestId: 'notif-modal-cancel-btn',
          },
        ];

  const notificationTitle =
    from === 'continue-notification'
      ? t('categorization.notificationModal.title')
      : t('categorization.notificationModal.titleWait');

  const notificationDescription =
    from === 'continue-notification'
      ? t('categorization.notificationModal.description')
      : t('categorization.notificationModal.descriptionWait');

  return (
    <>
      {from === 'categorization' ? (
        <ArrModal
          showModal={open}
          onClose={handleCancel}
          headerTitle={t('categorization.confirmationModal.title')}
          dataTestId="confirmation-modal"
          buttons={[
            {
              id: '1',
              label: t('common.cancel'),
              onClick: handleCancel,
              variant: 'secondary',
              dataTestId: 'copy-modal-cancel-btn',
            },
            {
              id: '2',
              label: t('common.proceed'),
              onClick: handleApply,
              variant: 'primary',
              dataTestId: 'copy-modal-confirm-btn',
            },
          ]}
          className={`${from}-modal`}
          autoFocusCloseButton={true}
        >
          <Box className="modal-container">
            <Typography
              className="typo-text headline3_size text-headings"
              tabIndex={0}
              data-testid={`confirmation-modal-message`}
            >
              {t('categorization.confirmationModal.message')}
            </Typography>
            <Typography
              className="typo-text body2_size text-body-strong"
              tabIndex={0}
              data-testid={`confirmation-modal-description`}
            >
              {t('categorization.confirmationModal.description')}
            </Typography>
          </Box>
        </ArrModal>
      ) : (
        <ArrModal
          showModal={open}
          onClose={handleCancel}
          buttons={notificationButtons}
          className={`notification-modal`}
          autoFocusCloseButton={true}
          dataTestId="notification-modal"
        >
          <Box className="modal-container">
            <Typography
              className="typo-text headline3_size text-headings"
              tabIndex={0}
              data-testid={`confirmation-modal-notification-title`}
            >
              {notificationTitle}
            </Typography>
            <Typography
              className="typo-text body2_size text-body-strong"
              tabIndex={0}
              data-testid={`confirmation-modal-notification-description-text`}
            >
              {notificationDescription}
            </Typography>
          </Box>
        </ArrModal>
      )}
    </>
  );
};

export default React.memo(ConfirmationModal);
